import React from "react";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";
import MCSSpace from "../../../components/MCSSpace";
import MCSReadonlyField from "../../../components/MCSReadonlyField";
import { DafHelper } from "../../../_helpers/DafHelper";

// DafTabOneRequestDetails is used to display details for TabOneRequest and TabTwoRequest
const DafTabOneRequestDetails = (props) => {
    let tabOneRequest = props.tabOneRequest;
    if (!tabOneRequest) return <></>;

    let displayCardAccepterId = typeof props.tabOneRequest.cardAccepterId != 'undefined';
    const euParticipationText = DafHelper.DisplayEURegionParticipation(tabOneRequest.euParticipation);

    return (
        <>
            <Grid>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Record#" text={tabOneRequest.recordNo} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Request Date" text={tabOneRequest.requestDate} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="VMID" text={tabOneRequest.vmid} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="VMID Merchant Name" text={tabOneRequest.vmidMerchantName} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Service Effective Date" text={tabOneRequest.serviceEffectiveDate} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="GMR Status" text={tabOneRequest.gmrStatus} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={12}>
                        <MCSReadonlyField label="VSS VMID Processing Result" text={tabOneRequest.processResultName} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Acquirer Name" text={tabOneRequest.acquirerName} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Acquirer BID" text={tabOneRequest.acquirerBid} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Acquirer Identifier (BIN)" text={tabOneRequest.acquirerIdentifier} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Acquirer Merchant ID" text={tabOneRequest.acquirerMerchantId} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="EU Region Participation" text={euParticipationText} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Merchant Email Address" text={tabOneRequest.merchantEmailAddress} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Merchant URL" text={tabOneRequest.merchantUrl} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        {displayCardAccepterId &&
                            <MCSReadonlyField label="Card Accepter ID" text={tabOneRequest.cardAccepterId} />
                        }
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={12}>
                        <MCSReadonlyField label="Merchant Street Address" text={tabOneRequest.merchantStreetAddress} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Merchant Country" text={tabOneRequest.merchantCountry} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Merchant City" text={tabOneRequest.merchantCity} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Merchant State" text={tabOneRequest.merchantState} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Merchant Postal Code" text={tabOneRequest.merchantPostalCode} />
                    </Col>
                </Row>
                <Row noGutter>
                    <Col noTopGutter noGutter lg={6}>
                        <MCSReadonlyField label="Merchant Address Country" text={tabOneRequest.merchantAddressCountry} />
                    </Col>
                    <Col noTopGutter noGutter lg={6}>
                    </Col>
                </Row>
            </Grid>
        </>
    );
};
export default DafTabOneRequestDetails;
